import { ajax } from './ajax';
import { fire } from './fire';

export const Rails = {
  ajax: ajax,
  fire: fire,
};
